import React from 'react';
import { Table, TableBody, TableCell, TableHead, TableRow, Typography, Box } from '@mui/material';
import { useSelector } from 'react-redux';

const CreatedCourseDetailsTable = () => {
    // Access the created courses with status from Redux
    const { createdCourses, loading, error } = useSelector((state) => state.createCourse);

    return (
        <Box mt={3}>
            {loading && <Typography>Loading created courses...</Typography>}
            {error && <Typography>Error loading created courses: {error}</Typography>}

            {createdCourses && createdCourses.length > 0 ? (
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Course Title</TableCell>
                            <TableCell>Course Level</TableCell>
                            <TableCell>Course Type</TableCell>
                            <TableCell>Days Per Week</TableCell>
                            <TableCell>Start Date</TableCell>
                            <TableCell>End Date</TableCell>
                            <TableCell>Status</TableCell>
                            <TableCell>Created At</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {createdCourses.map((course, index) => (
                            <TableRow key={index}>
                                {/* courseId is hidden */}
                                <TableCell>{course.title}</TableCell>
                                <TableCell>{course.level}</TableCell>
                                <TableCell>{course.courseType}</TableCell>
                                <TableCell>{course.daysPerWeek}</TableCell>
                                <TableCell>{new Date(course.startDate).toLocaleDateString()}</TableCell>
                                <TableCell>{new Date(course.endDate).toLocaleDateString()}</TableCell>
                                <TableCell>{course.status}</TableCell>
                                <TableCell>{new Date(course.createdAt).toLocaleString()}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            ) : (
                <Typography>No courses created yet.</Typography>
            )}
        </Box>
    );
};

export default CreatedCourseDetailsTable;
